import { ApiService } from '../../../../core/store/base/api-service';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})

export class FeatureService extends ApiService {

    apiSegment = 'brand-prodotti';

    /**
     * L'endpoint brand usa una API Resource, quindi risponde {"data": [...]},
     * a differenza degli endpoint legacy che restituiscono l'array nudo.
     */
    all() {

        return super.all().pipe(map((response: any) => response.data));

    }

}
